import { render, staticRenderFns } from "./CustomPageDetail.vue?vue&type=template&id=4282c613&scoped=true&"
import script from "./CustomPageDetail.vue?vue&type=script&lang=js&"
export * from "./CustomPageDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomPageDetail.vue?vue&type=style&index=0&id=4282c613&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4282c613",
  null
  
)

export default component.exports